<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マーク指示</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">グループ</label>
              <div class="list-input-content">
                <select id="cmb_MarkGroup" #cmb_MarkGroup forcedEnabledMode="true" [(ngModel)]="kymw1409Model.markGroup"
                  (change)="eventMarkGroupName_CHANGEHandler()" [tabindex]="0" [style.width.px]="200">
                  <ng-template ngFor let-item [ngForOf]="kymw1409Model.markGroupList">
                    <option value="{{item.code}}">{{item.lbl}}</option>
                  </ng-template>
                </select>
                <app-checkbox-label [label]="'すべての商品に同一の設定'" id="chk_GoodsFlagALL" [subid]="'chk_GoodsFlagALL'"
                  [(ngModel)]="kymw1409Model.goodsFlagALL" [disabled]="kymw1409Model.disabledGoodsFlagALL"
                  [tabindex]="0"></app-checkbox-label>
              </div>
            </div>
          </div>
          <!-- データグリッド定義(マーク一覧) -->
          <wj-flex-grid id="dtg_MarkListDetail" #dtg_MarkListDetail [itemsSource]="kymw1409Model.markInfoListDisp"
            [frozenColumns]="2" [isReadOnly]="true" [deferResizing]="true" [allowDragging]="'None'" [allowSorting]="true"
            [headersVisibility]="'Column'" [selectionMode]="'Row'" forcedEnabledMode="true" [tabindex]="0" class="always-scrollbars">
            <wj-flex-grid-column [minWidth]="5" [header]="' '" [width]="40" [binding]="'img_MarkFileName'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [style.text-align]="'center'">
                  <img src="{{cell.item.img_MarkFileName}}" [style.max-height.px]="20" [style.max-width.px]="20">
                </div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク'" [width]="350" [binding]="'MarkName'" [isReadOnly]="true">
            </wj-flex-grid-column>
            <ng-template ngFor let-col [ngForOf]="editColumns">
              <wj-flex-grid-column [minWidth]="5" [header]="col" [width]="colWidth" [binding]="col" [wordWrap]="false"
                [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" class="checkbox-cell" [(ngModel)]="cell.item[col]" [tabindex]="-1"
                    [disabled]="cell.item['Enabled'] === '0'" id="cb_{{col}}_{{cell.row.index}}"
                    (mouseup)="$event.stopPropagation()"
                    (change)="eventUseMark_CHANGEHandler({pCode: col, status: cell.item[col]})">
                </ng-template>
              </wj-flex-grid-column>
            </ng-template>
          </wj-flex-grid>

          <div class="block-row selected-mark-container">
            <div [style.text-align]="'center'">
              <img id="img_MarkFileName" src="{{kymw1409Model.imgMarkFileURL}}">
            </div>

            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">Ｐコード</label>
                <div class="list-input-content">
                  <select id="cmb_PCode" #cmb_PCode forcedEnabledMode="true" [(ngModel)]="kymw1409Model.pCode"
                    (change)="eventPCode_CHANGEHandler()" [tabindex]="0" class="pcode">
                    <ng-template ngFor let-item [ngForOf]="kymw1409Model.pCodeList">
                      <option value="{{item.PCode}}">{{item.PCode}}</option>
                    </ng-template>
                  </select>
                </div>

                <label class="list-input-title">商品名</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_GuideGoodsName" class="guide-goods-name" value="{{kymw1409Model.lblGuideGoodsName}}" readonly>
                </div>

                <label class="list-input-title">規格名</label>
                <div class="list-input-content">
                  <input type="text" id="lbl_GuideStandardName" class="guide-standard-name" value="{{kymw1409Model.lblGuideStandardName}}" readonly>
                </div>
              </div>

              <!-- データグリッド定義(選択マーク一覧)  -->
              <wj-flex-grid id="dtg_GoodsInfoDetail" #dtg_GoodsInfoDetail [frozenColumns]="1"
                [itemsSource]="kymw1409Model.selectedMarkList" [isReadOnly]="true" [deferResizing]="true"
                [allowDragging]="'None'" [allowSorting]="true" [headersVisibility]="'Column'" [selectionMode]="'Row'"
                [tabindex]="0">
                <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="120" [binding]="'MarkGroupName'">
                </wj-flex-grid-column>
                <wj-flex-grid-column [minWidth]="5" [header]="'マーク'" [width]="432" [binding]="'MarkNames'"
                  [wordWrap]="true">
                </wj-flex-grid-column>
              </wj-flex-grid>
            </div>
          </div>
        </div>
      </div>
      <div class="window-title-close">
        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <button [tabindex]="0" (click)="onClickWindowClose()"></button>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>